export const arrangeProducts = (
  products: Array<Dic<any>>,
  positions: Dic<any>
) => {
  // On crée une copie du tableau pour ne pas modifier l'original
  const result = Array(products.length).fill(null);

  // On place les produits selon l'objet positions
  Object.entries(positions).forEach(([pos, id]) => {
    const index = parseInt(pos, 10) - 1; // positions commence à 1
    const product = products.find((p) => p.id === id);
    if (product) {
      result[index] = product;
    }
  });

  // On remplit les trous avec les produits restants
  let remaining = products.filter(
    (p) => !Object.values(positions).includes(p.id)
  );
  for (let i = 0; i < result.length; i++) {
    if (result[i] === null && remaining.length > 0) {
      result[i] = remaining.shift();
    }
  }

  return result;
};

type Product = { id: string; name: string };
type Positions = Record<number, string>;

export const updatePositionsOnDrag = (
  arrangedItems: Array<Dic<any>>,
  positions: Positions,
  sourceIndex: number,
  targetIndex: number
): Positions => {
  // On clone l'objet positions pour éviter les effets de bord
  let newPositions = { ...positions };

  // Trouver l'id du produit déplacé
  const movedItemId = arrangedItems[sourceIndex].id;

  // Trouver les positions actuelles
  let currentPos = null;
  for (const [pos, id] of Object.entries(newPositions)) {
    if (id === movedItemId) {
      currentPos = parseInt(pos, 10);
      break;
    }
  }

  // Si le produit n'a pas de position, on prend son index + 1 (pour coller à la logique des positions 1-based)
  if (currentPos === null) {
    currentPos = sourceIndex + 1;
  } else {
    // Supprimer l'ancienne position du produit déplacé
    if (newPositions[currentPos] === movedItemId) {
      delete newPositions[currentPos];
    }
  }

  // Nouvelle position cible (1-based)
  const newPos = targetIndex + 1;

  // Si la position ne change pas, rien à faire
  if (currentPos === newPos) return newPositions;

  // Déplacement vers la droite (target > source)
  if (newPos > currentPos) {
    for (let pos = currentPos + 1; pos <= newPos; pos++) {
      if (newPositions[pos]) {
        newPositions[pos - 1] = newPositions[pos];
      } else {
        delete newPositions[pos - 1];
      }
    }
  }
  // Déplacement vers la gauche (target < source)
  else {
    for (let pos = currentPos - 1; pos >= newPos; pos--) {
      if (newPositions[pos]) {
        newPositions[pos + 1] = newPositions[pos];
      } else {
        delete newPositions[pos + 1];
      }
    }
  }

  // Placer le produit déplacé à la nouvelle position
  newPositions[newPos] = movedItemId;

  return newPositions;
};
